import activeState from '@components/ActiveState/activeStateSlice'
import intl from '@redux/reducers/intl'
import permissions from '@redux/reducers/permissions'
import session from '@redux/reducers/session'
import userCognito from '@redux/reducers/userCognito'
import userProfile from '@redux/reducers/userProfile'

export const shellReducers = {
  session,
  userProfile,
  userCognito,
  permissions,
  intl,
  activeState,
}
